import React from "react";
import PropTypes from "prop-types";

import { Label } from "semantic-ui-react";

const statusColor = {
  INSTALLED: "green",
  SHARED: "yellow",
};

function SharedResourceStatus({ status, size }) {
  return (
    <Label color={statusColor[status]} size={size}>
      {status}
    </Label>
  );
}

SharedResourceStatus.propTypes = {
  status: PropTypes.oneOf(["INSTALLED", "SHARED"]).isRequired,
  size: PropTypes.oneOf([
    "mini",
    "tiny",
    "small",
    "medium",
    "large",
    "big",
    "huge",
    "massive",
  ]),
};

SharedResourceStatus.defaultProps = { size: "small" };

export default SharedResourceStatus;
